import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "associated-classes",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "assoicated-classes" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
